import React, { Component } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import Select from "../../components/Input/Select/Select";

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import StringInput from "../../components/Input/StringInput/StringInput";
import Button from "../../components/Button/Button";
import { formValidation, filterErrorHandler } from "../../hoc/Shared/utility";
import { withNamespaces } from "react-i18next";
import JoditEditor from "jodit-react";
import ValidationError from "../../components/ValidationError/ValidationError";
import "jodit/build/jodit.min.css";
import { createAgentInbox, dropdownAgentInbox } from "../../store/ducks/agentInbox/actions";
import DateTimePicker from "../../components/DateTimePicker/DateTimePicker";
import moment from 'moment';

let categoryArry = [];

class AgentInboxCreate extends Component {
    state = {
        title: "",
        content: "",
        category_id: [],
        touched: false,
        error_message: "",
        formFilter:
        {
            show_date: '',
        },
        loading: true
    };

    componentDidMount() {
        formValidation("inbox_form");
        const listingArr = {};
        this.props.dropdownAgentInbox(listingArr);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.create_agent_inbox !== this.props.create_agent_inbox && nextProps.create_agent_inbox !== undefined) {
            if (nextProps.create_agent_inbox.data.responseCode === 200 && nextProps.create_agent_inbox.data.msgType === 'success') {
                this.setState({ touched: false });
                const { t } = this.props;
                Swal.fire({
                    title: t("global.record-saved"),
                    icon: nextProps.create_agent_inbox.data.msgType,
                    confirmButtonText: t("global.ok"),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.props.refreshHandler();
                        this.props.changePageHandler("listing");
                    }
                });
            } else {
                this.setState({
                    touched: true,
                    error_message: nextProps.create_agent_inbox.data.message,
                });
                Swal.close();
            }
        }

        if (nextProps.dropdown_agent_inbox !== this.props.dropdown_agent_inbox && nextProps.dropdown_agent_inbox !== undefined) {
            if (nextProps.dropdown_agent_inbox.data.responseCode === 200 && nextProps.dropdown_agent_inbox.data.msgType === 'success') {
                categoryArry = [];
                const { t } = this.props;
                Swal.close();
                let data = nextProps.dropdown_agent_inbox.data.data.category;
                Object.keys(data).map((item, i) => {
                    return categoryArry.push({
                        label: t('inbox.' + data[item].title),
                        value: data[item].id,
                        key: data[item].id
                    });
                });
                this.setState({ loading: false });
            }
            else {
                filterErrorHandler(nextProps.dropdown_agent_inbox.data.message);
            }
        }

        return true;
    }

    onInputChange = (event, langId) =>
    {
        let newInput = Object.assign({}, this.state.formFilter);
        if(langId && langId > 0)
        {
            if(newInput.reward_details[langId])
            {
                newInput.reward_details[langId][event.target.id] = event.target.value;
            }
            else
            {
                let newLangArr = {[event.target.id]: event.target.value};
                newInput.reward_details[langId] = newLangArr;
            }
        }
        else
        {
            newInput[event.target.id] = event.target.value;
        }

        this.setState({
            formFilter: newInput,
        });
    }

    postInboxHandler = (e) => {
        e.preventDefault();
        const { t } = this.props;

        Swal.fire({
            title: t("global.confirmation"),
            text: t("global.are-you-sure"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("global.save"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading();
                    },
                });

                let formData = new FormData();
                let showDate = this.state.formFilter.show_date ? moment(this.state.formFilter.show_date).format("yyyy-MM-DD HH:mm") : '';

                formData.append("title", this.state.title);
                formData.append("content", this.state.content);
                formData.append("category_id", this.state.category_id);
                formData.append("country_id", this.props.currentUser.country_id);
                formData.append("lang_id", this.props.currentUser.language_id);
                formData.append("show_date", showDate);

                this.props.createAgentInbox(formData);
            }
        });
    };

    getTitleHandler = (event) => {
        this.setState({ title: event.target.value });
    };

    getCategoryHandler = (event) => {
        this.setState({ category_id: event.target.value });
    };

    render() {
        const { t } = this.props;

        let defaultType = [
            {
                label: t("inbox.please-select"),
                value: "",
                selected: true,
            },
        ];

        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className="d-flex">
                        <div className="my-auto">
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler("listing")}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t("agent-inbox.page-title")}</h4>
                        </div>
                    </div>
                </div>

                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card  box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("agent-inbox.add-inbox")}</h4>
                            </div>

                            <div className="card-body pt-0">
                                {this.state.loading === true ? (
                                    <Skeleton count={4} />
                                ) : (
                                    <form method="post" id="inbox_form" className="form-horizontal" onSubmit={this.postInboxHandler} noValidate>
                                        <ValidationError formName="inbox_form" touched={this.state.touched} message={this.state.error_message} />
                                        <div className="row">
                                            <div className="col-12 form-group">
                                                <label htmlFor="title">{t("agent-inbox.title")}</label>
                                                <StringInput onChange={(event) => this.getTitleHandler(event)} id="title" name="title" className="form-control" />
                                            </div>
                                            <div className="col-12 form-group">
                                                <label>{t("agent-inbox.content")}</label>
                                                <JoditEditor
                                                    value={this.state.content}
                                                    onBlur={(newContent) => {
                                                        this.setState({
                                                            content: newContent,
                                                        });
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-12 form-group">
                                                <label>{t("agent-inbox.category")}</label>
                                                <Select
                                                    id="category_id"
                                                    name="category_id"
                                                    className="form-control"
                                                    options={defaultType.concat(categoryArry)}
                                                    onChange={this.getCategoryHandler}
                                                />
                                            </div>
                                            <div className="col-md-6 col-12 form-group">
                                                <label htmlFor="group">{t("agent-inbox.show-time")}</label>
                                                    <DateTimePicker
                                                        id="show_date"
                                                        name="show_date"
                                                        className="form-control filter-input"
                                                        singleDatePicker={true}
                                                        timePicker={true}
                                                        value={this.state.formFilter.show_date}
                                                        onChange={this.onInputChange}
                                                    />
                                            </div>
                                            <div className="col-12 form-group mb-0 justify-content-end">
                                                <div>
                                                    <Button typeButton="submit" classValue="btn btn-blue" idValue="submit" buttonName={t("global.save")} />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        create_agent_inbox: state.agentInbox.create_agent_inbox,
        dropdown_agent_inbox: state.agentInbox.dropdown_agent_inbox
    };
};

const mapDispatchToProps = {
    createAgentInbox,
    dropdownAgentInbox
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(AgentInboxCreate));